<template>
  <div>
    <div v-if="room && room.price">
      <currency-context tag="div" class="mt-4 whitespace-nowrap">
        <template v-slot="{ convert }">
          from
          <span class="font-bold fs-16" v-text="convert(room.price)"></span>
          /night
        </template>
      </currency-context>
    </div>
  </div>
</template>

<script>
import CurrencyContext from "../../core/CurrencyContext";
import { mapGetters } from "vuex";

export default {
  components: {
    CurrencyContext,
  },
  props: ["room"],
  methods: {
    openChat() {
      window.Trengo.Api.Widget.open("chat");
    },
  },
};
</script>
